import { Checkbox, CheckboxGroup } from "@chakra-ui/react";
import React from "react";

const CheckboxInput = ({ name, onChange, isChecked }) => {
  return (
    <CheckboxGroup>
      <Checkbox isChecked={isChecked} onChange={onChange}>
        {name}
      </Checkbox>
    </CheckboxGroup>
  );
};

export default CheckboxInput;
